export const DEFAULT_USER_PHOTO_URL =
  'https://images.nextforce.us/profiles/default_user.png'

export const USER_PHOTO_HEX_COLORS = [
  { dark: '#FFE2B3', light: '#E48D00' }, // yellow
  { dark: '#ACCFD5', light: '#00B6D5' }, // blue
  { dark: '#FFBBBB', light: '#FF6868' }, // pink
]
